/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { CloudAppConfig } from '@modules/ui-types'
import type Feature from '@modules/utils/feature'

import { getRawConfig } from '../reducers/config'

import type { ReduxState } from '@/types/redux'

export const getConfig = getRawConfig

type ConfigKey = Feature | keyof CloudAppConfig

export const getConfigForKey = (state: ReduxState, key: ConfigKey) => getRawConfig(state)?.[key]

export const isFeatureActivated = (state: ReduxState, feature: Feature) =>
  Boolean(getConfigForKey(state, feature))
